import { render, staticRenderFns } from "./SHTakeoutCard.vue?vue&type=template&id=36e42e8e"
import script from "./SHTakeoutCard.vue?vue&type=script&lang=ts"
export * from "./SHTakeoutCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports